import React from 'react';
import {
  TextField
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import './styles.scss';
import { convertNumberToCurrency } from '../../utils/helpers';

const FormInputCurrency = ({
  title,
  name,
  validate,
  placeholder = 'Chọn...',
  type,
  className = 'form-control',
  titleClassName = 'text-dark',
  InputProps = {
    readOnly: false,
  },
  ...rest
}) => {
  const { control, errors, setValue } = useFormContext();
  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={validate}
        placeholder={placeholder}
        render={({ name, onBlur, ref, value }) => (
          <>
            <label className={titleClassName}>
              {title}{validate?.required ? <span className='required'></span> : null}
            </label>
            <TextField
              type={type}
              placeholder={placeholder}
              value={value}
              ref={ref}
              onBlur={onBlur}
              name={name}
              fullWidth
              className={className}
              InputProps={InputProps}
              onChange={(event) => {
                const numberPattern = /\d+/g;
                const { name, value } = event.target;
                if (value === '') return setValue(name, '');
                const number = value?.replace(/^0+/, '').match(numberPattern)?.join('');
                setValue(name, convertNumberToCurrency(number));
              }}
              {...rest}
            />
            {validate && errors[name] ? (
              <span className='error'>{errors[name] && errors[name].message}</span>
            ) : null}
          </>
        )
        }
      />
    </>
  );
};

export default FormInputCurrency;
